var setupSafeApply = function($rootScope) {
  $rootScope.safeApply = function(f) {
    if (!$rootScope.$$phase) { return $rootScope.$apply(f); }
    else if (f && typeof(f) === 'function') { f(); }
  }
}

export default setupSafeApply;
